import { ColumnDef } from '@tanstack/react-table';
import { ScheduledPendingStocksReport } from 'contracts/scheduledRepports';
import { DataTableUtils, Formatter } from 'utils';
import { downloadReport } from '../utils';

type GetColumns = () => ColumnDef<ScheduledPendingStocksReport>[];

const dt = new DataTableUtils<ScheduledPendingStocksReport>();

export const getColumns: GetColumns = () => {
  return [
    dt.buildColumn({
      accessorKey: 'created_at',
      title: 'Requisitado em',
      content: (row) => Formatter.dateTime(row.created_at),
    }),
    dt.buildColumn({
      accessorKey: 'finished_at',
      title: 'Finalizado em',
      content: (row) =>
        row.finished_at ? Formatter.dateTime(row.finished_at) : '---',
    }),
    dt.buildColumn({
      accessorKey: 'ag_date_start',
      title: 'Data AG',
      content: (row) => {
        const { ag_date_start, ag_date_end } = row;

        if (!ag_date_start) {
          return '---';
        }

        if (ag_date_start === ag_date_end) {
          return Formatter.date(ag_date_start);
        }

        const parts = [Formatter.date(ag_date_start)];

        if (ag_date_end) {
          parts.push(Formatter.date(ag_date_end));
        }

        return parts.join(' - ');
      },
    }),
    dt.buildStatusColumnForScheduledReports({
      onDownloadButtonClick: downloadReport,
    }),
  ];
};
